import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import keyBy from 'lodash-es/keyBy';
import omit from 'lodash-es/omit';
import { ShoreMasterDepartment } from '../lookups';
import { IWarehouseUser } from './warehousePermissionsInterfaces';

interface IWarehousePermissionState {
  users: Record<string, IWarehouseUser>;
}

const initialState: IWarehousePermissionState = {
  users: {}
};

// tslint:disable: no-empty
const warehousePermissionsSlice = createSlice({
  initialState,
  name: 'warehousePermissions',
  reducers: {
    deleteUser: (_, action: PayloadAction<{ sid: string; departmentId: number }>) => {},
    fetchUsers: (_, departmentId: PayloadAction<ShoreMasterDepartment>) => {},
    removeUser: (state, action: PayloadAction<{ sid: string; departmentId: number }>) => {
      state.users = omit(state.users, `${action.payload.sid}_${action.payload.departmentId}`);
    },
    setUsers: (state, action: PayloadAction<IWarehouseUser[]>) => {
      state.users = { ...state.users, ...keyBy(action.payload, x => `${x.sid}_${x.departmentId}`) };
    },
    updateUser: (_, user: PayloadAction<IWarehouseUser>) => {}
  }
});

export const { actions: warehousePermissionsActions, reducer: warehousePermissionsReducer } = warehousePermissionsSlice;
